import { Card, Badge, Table } from 'react-bootstrap';
import type { TeamSessionSummary } from '../types/api.types';
import { parsePoints, getTeamInfo, calculateSessionTotals } from '../utils/teamCompetition';

interface TeamSessionResultsProps {
  teamWinner: string | null | undefined;
  teamACaptainID: string | number | null | undefined;
  teamACaptainName: string | null | undefined;
  teamBCaptainID: string | number | null | undefined;
  teamBCaptainName: string | null | undefined;
  sessionResults: TeamSessionSummary[] | null | undefined;
}

interface TeamCaptainRowProps {
  teamClass: string;
  teamLabel: string;
  labelStyle: { fontSize: 'large' | 'small' };
  captainName: string | null | undefined;
  captainID: string | number | null | undefined;
}

function TeamCaptainRow({ teamClass, teamLabel, labelStyle, captainName, captainID }: TeamCaptainRowProps) {
  return (
    <tr>
      <td style={{ padding: '5px', textAlign: 'center' }}>
        <Badge className={teamClass} style={labelStyle}>
          {teamLabel}
        </Badge>
      </td>
      <td style={{ padding: '5px' }}>
        <span>{` Captained by ${captainName} `}</span>
      </td>
      <td style={{ padding: '5px' }}>
        <img src={`/assets/${captainID}.jpg`} height="45px" alt="" />
      </td>
    </tr>
  );
}

export default function TeamSessionResults({
  teamWinner,
  teamACaptainID,
  teamACaptainName,
  teamBCaptainID,
  teamBCaptainName,
  sessionResults,
}: TeamSessionResultsProps) {
  if (!teamWinner || !sessionResults || sessionResults.length === 0) {
    return null;
  }

  const teamA = getTeamInfo(sessionResults[0].teamA, teamWinner);
  const teamB = getTeamInfo(sessionResults[0].teamB, teamWinner);
  const total = calculateSessionTotals(sessionResults);

  return (
    <Card>
      <Card.Header>Last Ryd-Her Cup</Card.Header>
      <Card.Body>
        <div>
          <table>
            <tbody>
              <TeamCaptainRow
                teamClass={teamA.class}
                teamLabel={teamA.label}
                labelStyle={teamA.labelStyle}
                captainName={teamACaptainName}
                captainID={teamACaptainID}
              />
              <tr>
                <td style={{ padding: '5px', textAlign: 'center' }}>
                  <b> vs </b>
                </td>
              </tr>
              <TeamCaptainRow
                teamClass={teamB.class}
                teamLabel={teamB.label}
                labelStyle={teamB.labelStyle}
                captainName={teamBCaptainName}
                captainID={teamBCaptainID}
              />
            </tbody>
          </table>
          <Table>
            <thead>
              <tr>
                <th>Session</th>
                <th>Format</th>
                <th style={teamA.headingStyle}>{teamA.name}</th>
                <th style={teamB.headingStyle}>{teamB.name}</th>
              </tr>
            </thead>
            <tbody>
              {sessionResults.map((session) => (
                <tr key={session.sessionNum}>
                  <td>{`${session.sessionNum} (Day ${session.day})`}</td>
                  <td>{session.formatVariation ? `${session.format} - ${session.formatVariation}` : session.format}</td>
                  <td style={{ textAlign: 'center' }}>{parsePoints(session.teamAPoints)}</td>
                  <td style={{ textAlign: 'center' }}>{parsePoints(session.teamBPoints)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ fontWeight: 'bold' }}>
                <td>Total</td>
                <td />
                <td style={{ textAlign: 'center' }}>{total.teamAPoints}</td>
                <td style={{ textAlign: 'center' }}>{total.teamBPoints}</td>
              </tr>
            </tfoot>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
}
